import { Suspense } from "react";
// import KeepAlive from "react-activation";

import Home from "@pages/Home";
import HomeDefault from "@components/HomeMain/Default";
import HomeAlertDetail from "@components/HomeMain/AlertDetail";

import Daily from "@pages/Daily";
import DailyDefault from "@components/DailyMain/Default";
import DailyDetail from "@components/DailyMain/Detail";
import DailyAlertDetail from "@components/DailyMain/AlertDetail";

import Hourly from "@pages/Hourly";
import HourlyDefault from "@components/HourlyMain/Default";
import HourlyAlertDetail from "@/components/HourlyMain/AlertDetail";

import SunMoon from "@pages/SunMoon";
import SunMoonDefault from "@components/SunMoonMain/Default";

import RahuKaal from "@pages/RahuKaal";
import RahuKaalDefault from "@components/RahuKaalMain/Default";

import News from "@pages/News";
import NewsDefault from "@/components/NewsMain/Default";
import NewsDetl from "@pages/NewsDetl";

import NotFound from "@pages/404";
import ErrorView from "@pages/ErrorView";
import PrivacyPolicy from "@pages/PrivacyPolicy";
import { RouteObject } from "react-router-dom";

const routes = [
  {
    path: "/",
    element: <Navigate to={"/home"} />,
  },
  {
    path: "/home",
    element: <Home />,
    children: [
      {
        path: "",
        element: <HomeDefault />,
      },
      {
        path: "detail",
        element: <HomeAlertDetail />,
      },
    ],
  },
  {
    path: "/now",
    element: <Home />,
    children: [
      {
        path: "",
        element: <HomeDefault />,
      },
      {
        path: "detail",
        element: <HomeAlertDetail />,
      },
    ],
  },
  {
    path: "/hourly",
    element: <Hourly />,
    children: [
      {
        path: "",
        element: <HourlyDefault />,
      },
      {
        path: "alertdetail",
        element: <HourlyAlertDetail />,
      },
    ],
  },
  {
    path: "/daily",
    element: <Daily />,
    children: [
      {
        path: "",
        element: <DailyDefault />,
      },
      {
        path: "alertdetail",
        element: <DailyAlertDetail />,
      },
      {
        path: "/daily/detail/:index",
        element: <DailyDetail />,
      },
    ],
  },
  {
    path: "/sun-moon",
    element: <SunMoon />,
    children: [
      {
        path: "",
        element: <SunMoonDefault />,
      },
    ],
  },
  {
    path: "/rahu-kaal",
    element: <RahuKaal />,
    children: [
      {
        path: "",
        element: <RahuKaalDefault />,
      },
    ],
  },
  {
    path: "/news",
    element: <News />,
    children: [
      {
        path: "",
        element: <NewsDefault />,
      },
      {
        path: "/news/detail",
        element: <NewsDetl />,
      },
    ],
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicy />,
  },
  {
    path: "/notfound",
    element: <NotFound />,
  },
  {
    path: "*",
    element: <Navigate to="/notfound" />,
  },
  {
    path: "/error",
    element: <ErrorView />,
  },
];

const BasicRouter: React.FC = () => {
  // 抽离公共逻辑：统一 Suspense 包裹
  const withSuspense = (element: React.ReactNode) => <Suspense fallback={<Loading />}>{element}</Suspense>;

  // 递归渲染路由（极简版）
  const renderRoutes = (routeList: RouteObject[]) =>
    routeList.map((route, index) => (
      <Route key={`${route.path}-${index}`} path={route.path} element={withSuspense(route.element)}>
        {route.children && renderRoutes(route.children)}
      </Route>
    ));

  return <Routes>{renderRoutes(routes)}</Routes>;
};
export { routes };
export default BasicRouter;
